import PropTypes from 'prop-types';
import React from 'react';

import styles from '../commonStyles.module.scss';

const StatusItem = ({ backgroundColor, value = '-', isDisabled = false }) => (
  <span
    className={[styles.container, 'font-s-10'].join(' ')}
    style={{ backgroundColor, opacity: isDisabled ? 0.5 : 1 }}
  >
    {value}
  </span>
);

StatusItem.propTypes = {
  value: PropTypes.string,
  backgroundColor: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default StatusItem;
